import React, { Component } from "react";
import {
    DataGrid,
    Editing,
    Column,
    Paging,
    Pager,
    FormItem,
    StateStoring,
} from "devextreme-react/data-grid";
import uiInfo from "../../ui-info";
import PaginaToolbar from "../../components/PaginaToolbar";
import { criarFormulasIptuDs } from "../../DataSources";

const localStorageKey = "cadastroFormulasIptuGridState";

export default class FormulasIptuBox extends Component {
    constructor() {
        super();
        this._gridInstance = React.createRef();
        this.onAtualizandoRow = this.onAtualizandoRow.bind(this);
    }

    onAtualizandoRow(e) {
        e.cancel = true;
        this.props.history.push("formulasiptu/editar/" + e.data.id);
    }

    render() {
        return (
            <React.Fragment>
                <div className={'content-block dx-card responsive-paddings'}>
                    <PaginaToolbar titulo="Fórmulas de IPTU" novoCb={this.novoRegistro.bind(this)}>
                        <DataGrid
                            ref={grid => this._gridInstance = grid}
                            dataSource={criarFormulasIptuDs()}
                            showBorders={true}
                            rowAlternationEnabled={true}
                            remoteOperations={true}
                            columnAutoWidth={true}
                            columnHidingEnabled={true}
                            focusedRowEnabled={true}
                            wordWrapEnabled={window.innerWidth < 800}
                            filterSyncEnabled={true}
                            onEditingStart={this.onAtualizandoRow}>
                            <StateStoring enabled={true} type={'localStorage'} storageKey={localStorageKey} />
                            <Editing allowDeleting={true} allowUpdating={true} mode />
                            <Column dataField={'sequencial'} caption={"#"} allowEditing={false} width={80} alignment={'center'} />
                            <Column dataField={'prefeituraId'} caption={"Prefeitura"} visible={false}>
                                <FormItem visible={false}></FormItem>
                            </Column>
                            <Column dataField={'titulo'} caption={"Título"} />
                            <Column dataField={'formula'} caption={"Formula"} />
                            <Paging defaultPageSize={uiInfo.tamanhoPaginaPadrao} />
                            <Pager
                                showPageSizeSelector={true}
                                allowedPageSizes={uiInfo.tamanhoPaginaOpcoes}
                            />
                        </DataGrid>
                    </PaginaToolbar>
                </div>
            </React.Fragment>
        );
    }

    novoRegistro() {
        let gridState = this._gridInstance.instance.state();
        localStorage.setItem(localStorageKey, JSON.stringify(gridState));
        this.props.history.push("formulasiptu/novo");
    }
    
}
